<template>
    <div class="page-container ssa-centered-content-page">
        <div class="center-content">
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CenteredContentLayout'
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide";

.page-container {
    background-color: $light-100;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.center-content {
    width: 800px;
    position: absolute;
    top: 20px;
    border-radius: 3px;
    border: $border;
    background-color: $white;
}

.content {
    height: 100%;
    min-height: 200px;
}
</style>
